module.exports = __webpack_public_path__ + "img/Tim.8c1bbaee.jpg";